export default "/images/car.png?688967ec07829817506e05d9ba614fe2";